// src/services/readingService.ts

import apiClient from '../utils/apiClient';
import { ReadingUpdate,UpdateReadingResponse } from '../components/planning/ServiceCard/types';


// Define the type for the Oremus API config object
interface OremusApiConfig {
  version: string;
  vnum: string;
  fnote: string;
  show_ref: string;
  headings: string;
}

// Define the default configuration for Oremus Bible API requests
const oremusApiConfig: OremusApiConfig = {
  version: 'NRSVAE',  // Set Bible version (e.g., NRSV, NRSVAE, AV)
  vnum: 'YES',        // Show verse numbers
  fnote: 'NO',        // Hide footnote markers
  show_ref: 'YES',    // Show passage references
  headings: 'NO',     // Hide section headings
};

// Helper function to convert the config object to query string
const generateApiParams = (config: OremusApiConfig): string => {
  return Object.keys(config)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(config[key as keyof OremusApiConfig])}`)
    .join('&');
};

function splitBibleReferences(reference: string): string[] {
  const normalizedRef = reference.replace(/\s+/g, ' ').trim();
  return normalizedRef
    .split(/\s+(?:and|or)\s+/i)
    .map(ref => ref.trim())
    .filter(ref => ref.length > 0);
}

// Function to fetch Bible passage with default configurations
export const fetchBiblePassage = async (reference: string): Promise<any> => {
  try {
    // Split references and fetch each one individually
    const references = splitBibleReferences(reference);
    
    const responses = await Promise.all(
      references.map(async (ref) => {
        const response = await apiClient.get(`/readings/passage`, {
          params: {
            reference: ref,
            ...oremusApiConfig  // Merged with other params
          },
        });

        return {
          reference: ref,
          text: response.data.text || response.data
        };
      })
    );

    return responses;

  } catch (error) {
    console.error('Error fetching Bible passage:', error);
    throw error;
  }
};

// src/services/readingService.ts
// Add this new function alongside your existing ones

export const bulkUpdateReadings = async (
  serviceId: number, 
  updates: ReadingUpdate
): Promise<UpdateReadingResponse> => {
  try {
    console.log('Sending bulk update request:', {
      serviceId,
      updates
    });

    const response = await apiClient.put(
      `/readings/${serviceId}/bulk`,
      updates
    );

    console.log('Bulk update response:', response.data);
    
    return {
      success: true,
      service: response.data
    };
  } catch (error) {
    console.error('Error updating readings:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'An unknown error occurred'
    };
  }
};